<template>
    <div>
        <div
            class="drop-area"
            @dragover.prevent="dragOver"
            @dragleave.prevent="dragLeave"
            @drop.prevent="dropFile"
            @click="$refs.fileInput.click()"
            :class="{ 
                'drag-over': isDragOver, 
            }"
            >
            <div class="upload-section">
            <div class="flex row gap-10 align-center justify-start w-full">
                <button class="flex justify-center transparent button action-buttons file-button flex-1">
                <img src="@/assets/pin.svg" class="plus" color="black"/>
                    Upload File
                </button>
                <div class="flex-1">or drag & drop</div>

            </div>
            </div>
            <input type="file" ref="fileInput" :accept="'.csv'" style="display: none" @change="handleFileChange" />
        </div>
        <div v-if="selectedFile" class='current-file-section mt-10' >
            <div class="file-info">
                <div class="label-extension">{{ selectedFile.name.split('.').slice(-1)[0] }}</div>
                <img src="@/assets/file.svg" class="image-upload"/>
            </div>
            <div class="text-left file-name flex column"> 
                <div>{{ selectedFile.name }}</div>
                <div class="file-size">{{ Utils.calculateFileSize(selectedFile.size) }}</div>
            </div>
        </div>
        <div v-else class='current-file-section mt-10 missing-file'
            @dragover.prevent="dragOver"
            @dragleave.prevent="dragLeave"
            @drop.prevent="dropFile"
            @click="$refs.fileInput.click()"
        >
            <div class="file-info">
            <img src="@/assets/file.svg" class="image-upload"/>
            </div>
            <div class="text-left file-name"> 
                No file uploaded
            </div>
        </div>
    </div>
</template>


<script setup>

    import { ref, defineEmits } from 'vue'
    import Utils from '@/utils';
    const emit = defineEmits(['file-selected'])

    const selectedFile = ref(null);
    const isDragOver = ref(false)

    function dragLeave() {
        isDragOver.value = false;
    }
    function dropFile(event) {
        isDragOver.value = false;
        handleFileChange(event);
    }
    function dragOver() {
        isDragOver.value = true;
    }

    function handleFileChange(event) {
        const files = event.target.files || event.dataTransfer.files;
        if (files.length > 0) {
            console.log(files[0])
            selectedFile.value = files[0];
            emit('file-selected', selectedFile.value);
        }
    }

</script>


<style scoped lang="scss">
  .drop-area {
    position: relative;
    width: 335px;
    height: fit-content;
    min-width: 300px;
    background-color: white;
    display: flex;
    align-items: flex-start;
    color: #8997A5;
  
    cursor: pointer;
    box-sizing: border-box;
    &:hover .upload-section {
      border-color: var(--primary-color);
    }

  }
  .upload-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding-right: 20px;
    border-radius: 5px;
    border-radius: .5rem;
    border-style: dashed;
    border-width: 2px;
    transition: all 0.3s;
    width: 100%;
    border-color: rgb(224 226 236);
    font-size: 14px;
    i {
      word-break: break-word;
    }
  }

  .current-file-section {
  display: flex;
  gap: 10px;
  background-color: white;
  border-radius: 5px;
  padding: 10px 0px;
  max-width: 335px;
}


.file-name {
  font-size: 14px;
  color: rgb(0, 0, 0);
  font-weight: 500;
  display: flex;
  align-items: flex-start;
}


.file-info {
  position: relative;
  margin-left: 10px;
  img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
  .label-extension {
    position: absolute;
    color: white;
    font-size: 11px;
    width: 30px;
    top: 15px;
    left: 5px;
    font-weight: 600;
    text-align: center;
  }
}
.missing-file {
  cursor: pointer;
  img {
    filter: grayscale(100%);
    opacity: 0.3;
  }
  .file-name {
    color: rgb(120, 120, 120);
  }
  &:hover {
    img {
      filter: grayscale(80%);
      opacity: 0.4;
    }
    .file-name {
      color: rgb(0, 0, 0);
    }
  }
}
.file-size {
    font-size: 0.8rem;
    color: rgb(116 119 127);
}
</style>